import {useEffect,useState} from "react";
import {useNavigate} from "react-router-dom";
import {Box,Link,TextField} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {DefaultConfig,evaluateReadOnly} from '../../../core/utilities/Utilities';
import {isExternalLink,normalizeLink} from '../../../core/utilities/UrlSafety';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldWebLink=({row,fieldName,application,recordRules,readOnly,setFieldValue,setFieldChanged})=>{
    const fieldProp=row?.[fieldName];
    const fieldValue=fieldProp?.value;
    const readOnlyEvaluated=evaluateReadOnly(readOnly,recordRules,fieldProp);
    const [inputValue,setInputValue]=useState(fieldValue||"");
    const [isFieldChanged,setIsFieldChanged]=useState(false);
    const navigate=useNavigate();
    const theme=useTheme();

    useEffect(()=>{
        setInputValue(fieldValue||"");
    },[fieldValue]);

    return (
        <Box sx={{flex:1,minWidth:0}}>
            <TextField
                label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                value={inputValue}
                margin="normal"
                sx={{...(readOnlyEvaluated&&{"& .MuiOutlinedInput-root":{backgroundColor:readOnlyBackgroundColor,},}),}}
                style={{marginTop:"0px",marginBottom:"8px"}}
                id={fieldName}
                name={fieldName}
                type={fieldProp?.ui_type}
                required={fieldProp?.required?fieldProp?.required:false}
                error={fieldProp?.validation_error?fieldProp?.validation_error:false}
                helperText={fieldProp?.validation_error_message?fieldProp?.validation_error_message:''}
                variant="outlined"
                size="small"
                fullWidth
                onChange={(e)=>{
                    if(!isFieldChanged){setIsFieldChanged(true)}
                    setInputValue(e.target.value);
                    setFieldChanged();
                }}
                onBlur={(e)=>{if(isFieldChanged){setFieldValue(fieldName,inputValue)};}}
                InputProps={{
                    readOnly: readOnlyEvaluated,
                    sx:{
                        backgroundColor:readOnlyEvaluated?readOnlyBackgroundColor:undefined,
                        ...(readOnlyEvaluated&&inputValue&&{"& .MuiInputBase-input":{display:"none",},}),
                    },
                    startAdornment:
                        readOnlyEvaluated&&inputValue?(
                            <Box
                                sx={{
                                    whiteSpace:"nowrap",
                                    overflow:"hidden",
                                    textOverflow:"ellipsis",
                                    padding:"8.5px 0px",
                                }}>
                                <Link
                                    component="button"
                                    underline="hover"
                                    sx={{
                                        color:theme.list_link_color||theme.palette.primary.main,
                                        cursor:"pointer",
                                    }}
                                    onClick={(e)=>{
                                        e.stopPropagation();
                                        e.preventDefault();
                                        const url=normalizeLink(inputValue);
                                        if(!url) return;
                                        if(isExternalLink(inputValue)){
                                            window.open(url, "_blank", "noopener,noreferrer");
                                        } 
                                        else{
                                            navigate(url);
                                        }
                                    }}>
                                    {inputValue}
                                </Link>
                            </Box>
                        ):null,
                }}
            />
        </Box>
    );
}

export default FieldWebLink;
